import { Grid, DialogTitle, DialogContent } from '@mui/material';
import { RoundedDialog, StandardDialogActions } from '../../../../../Global/Components';
import TasksTable from './TasksTable';

export default function TasksTableDialog({ title, boxParams, open, onClose, itemId }) {
  return (
    <RoundedDialog open={open} maxWidth="xl" fullWidth onClose={onClose} className="scroll-bar">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container item alignContent="flex-start" sx={{ height: '70vh' }}>
          <TasksTable boxParams={boxParams} itemId={itemId} />
        </Grid>
      </DialogContent>
      <StandardDialogActions onClose={onClose} />
    </RoundedDialog>
  );
}
